import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgIsOfferedWithPrescriptions = function SvgIsOfferedWithPrescriptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    d: "M20 12.5a.75.75 0 0 0-.75.75V14h2.25a.75.75 0 0 1 0 1.5h-2.25v.75c0 .414.336.75.75.75h1.5a.75.75 0 0 1 0 1.5H20a2.25 2.25 0 0 1-2.25-2.25v-3A2.25 2.25 0 0 1 20 11h1.5a.75.75 0 0 1 0 1.5H20ZM14 27.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM18.5 27.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM23.75 27a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM14.75 25.5a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H15.5v.5h2.75a.75.75 0 0 1 0 1.5H15.5v1.25a.75.75 0 0 1-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M21.75 20a.75.75 0 0 0-.75.75v4a.75.75 0 0 0 1.5 0V24h2.75a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.5Zm2.75 2.5h-2v-1h2v1Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M26.75 8A2.25 2.25 0 0 1 29 10.25v19.5A2.25 2.25 0 0 1 26.75 32h-13.5A2.25 2.25 0 0 1 11 29.75v-19.5A2.25 2.25 0 0 1 13.25 8h13.5ZM12.5 10.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v19.5a.75.75 0 0 1-.75.75h-13.5a.75.75 0 0 1-.75-.75v-19.5Z",
    clipRule: "evenodd"
  })));
};

export { SvgIsOfferedWithPrescriptions as default };
//# sourceMappingURL=is-offered-with-prescriptions.svg.js.map
